import React from "react";
import { CurrencyInput } from "@picklebet/ui";
import { useFiatCurrency } from "hooks/firestore/user/useFiatCurrency";
import { convertAmountToCents, convertCentsToAmount } from "common/currency";

import * as styles from "@/features/betslip/components/parts/StakeInput.module.scss";

type StakeInputProps = {
  value: number;
  onChange: (cents: number) => void;
  disabled?: boolean;
  testId?: string;
  onFocus?: () => void;
  onBlur?: () => void;
};

export const StakeInput = ({
  value,
  onChange,
  disabled,
  testId = "stake-input",
  onFocus,
  onBlur,
}: StakeInputProps) => {
  const fiatCurrency = useFiatCurrency();

  return (
    <CurrencyInput
      data-testid={testId}
      containerClassName={styles.container}
      inputClassName={styles.input}
      wrapperClassName={styles.wrapper}
      currency={fiatCurrency}
      value={value > 0 ? convertCentsToAmount(value) : undefined}
      onChange={(dollars) => onChange(convertAmountToCents(dollars))}
      onFocus={onFocus}
      onBlur={onBlur}
      disabled={disabled}
      canClear={false}
    />
  );
};
